import axios from 'axios';
import { i18n as I18n } from 'i18next';

import handleAxiosError from 'lib/errors/handleAxiosError';

export async function fetchAndAddTranslation(
  serviceUrl: string,
  i18n: I18n,
  language: string,
): Promise<Record<string, unknown>> {
  const [{ data: customCopy }] = await Promise.all([
    axios.get<Record<string, unknown>>(serviceUrl).catch((error) => {
      let url: URL | undefined;
      try {
        url = new URL(serviceUrl);
      } catch (e) {
        // don't assign anything to url if serviceUrl is not a valid url
      }
      handleAxiosError({
        error,
        method: 'GET',
        // Leave out QS because this causes Sentry to truncate error
        uri: url instanceof URL ? `${url.origin}${url.pathname}` : serviceUrl,
      });
    }),
    i18n.loadLanguages([language]),
  ]);

  i18n.addResourceBundle(language, 'translation', customCopy, true, true);
  return customCopy;
}
